var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-ref": "component.plate" } },
    [
      !_vm.newAsset.plate
        ? _c(
            "div",
            {
              staticClass: "container mb-3",
              attrs: { "data-ref": "!newAsset.plate" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "d-flex justify-content-end align-content-center"
                },
                [
                  _c("floating-button", {
                    attrs: { button_color: "btn-primary", relative: true },
                    on: { clicked: _vm.createAsset }
                  })
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.newAsset.plate
          ? _c("div", { staticClass: "p-3 mb-2 card ml-auto  mr-auto" }, [
              _c("div", { staticClass: "card-body bg-info" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-6 col-12 mb-4 mb-md-0 plate" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.plateModel,
                            expression: "plateModel"
                          }
                        ],
                        ref: "plate_0",
                        attrs: {
                          autocomplete: "off",
                          id: _vm.plateModelId,
                          type: "text",
                          title: "create new asset",
                          maxlength: "8"
                        },
                        domProps: { value: _vm.plateModel },
                        on: {
                          keyup: function($event) {
                            _vm.onPlateInput(0, "plate_")
                          },
                          keydown: function($event) {
                            if (!$event.altKey) {
                              return null
                            }
                            _vm.altKeyPressed = true
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.plateModel = $event.target.value
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "offset-2 col-md-2 col-4 align-self-center text-right"
                    },
                    [
                      _c(
                        "BaseButtonRound",
                        {
                          staticClass: "ml-3 my-0",
                          attrs: {
                            btn_type: "btn-primary",
                            type: "div",
                            small: false,
                            tooltip: false
                          },
                          nativeOn: {
                            click: function($event) {
                              _vm.storeAsset("plate")
                            }
                          }
                        },
                        [
                          _c("template", { slot: "content" }, [
                            _c(
                              "i",
                              {
                                staticClass: "material-icons",
                                attrs: { "aria-hidden": "true" }
                              },
                              [_vm._v("save")]
                            )
                          ])
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "col-md-2 col-4 align-self-center text-right"
                    },
                    [
                      _c(
                        "BaseButtonRound",
                        {
                          staticClass: "my-0",
                          attrs: {
                            btn_type: "btn-danger",
                            type: "div",
                            small: false,
                            tooltip: false
                          },
                          nativeOn: {
                            click: function($event) {
                              return _vm.cancelAsset($event)
                            }
                          }
                        },
                        [
                          _c("template", { slot: "content" }, [
                            _c(
                              "i",
                              {
                                staticClass: "material-icons",
                                attrs: { "aria-hidden": "true" }
                              },
                              [_vm._v("cancel")]
                            )
                          ])
                        ],
                        2
                      )
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _vm.altKeyPressed
                ? _c(
                    "div",
                    {
                      staticClass:
                        "small p-1 m-1 bg-warning z-depth-1 align-center cursor-pointer",
                      on: {
                        click: function($event) {
                          _vm.altKeyPressed = false
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                    Do not press the Alt key. Click here to continue editing the plate\n                "
                      )
                    ]
                  )
                : _vm._e()
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "section",
            { key: _vm.loading },
            _vm._l(_vm.plates, function(plate) {
              return _c("div", { key: plate.id, staticClass: "container" }, [
                _c("div", { staticClass: "row mb-1" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-6 col-12 mb-2 mb-md-0 plate" },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(plate.value) +
                          "\n                    "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-md-4 col-8 align-self-center text-left text-md-right"
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.setDate(plate.updated_at)) +
                          "\n                    "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "col-md-2 col-4 align-self-center text-right"
                    },
                    [
                      _c(
                        "BaseButtonRound",
                        {
                          staticClass: "my-0",
                          attrs: {
                            btn_type: "btn-danger",
                            type: "div",
                            small: false,
                            tooltip: false
                          },
                          nativeOn: {
                            click: function($event) {
                              _vm.confirmDelete(plate)
                            }
                          }
                        },
                        [
                          _c("template", { slot: "content" }, [
                            _c(
                              "i",
                              {
                                staticClass: "material-icons",
                                attrs: { "aria-hidden": "true" }
                              },
                              [_vm._v("delete")]
                            )
                          ])
                        ],
                        2
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("hr", { staticClass: "d-block d-md-none mb-2" })
              ])
            })
          )
        : _c(
            "div",
            {
              key: _vm.loading,
              staticClass: "progress md-progress primary-color-dark"
            },
            [_c("div", { staticClass: "indeterminate" })]
          ),
      _vm._v(" "),
      _vm.showModal
        ? _c(
            "simple-modal",
            {
              attrs: {
                footer: {
                  cls: "pr-0"
                }
              },
              on: {
                onfirm: _vm.deleteAsset,
                close: _vm.cancelDelete,
                cancel: _vm.cancelDelete
              }
            },
            [
              _c(
                "h3",
                {
                  staticClass: "h3-responsive",
                  attrs: { slot: "header" },
                  slot: "header"
                },
                [_vm._v("\n                Delete from records?\n            ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mt-1", attrs: { slot: "body" }, slot: "body" },
                [
                  _c("div", { staticClass: "mb-3" }, [
                    _c("div", { staticClass: "plate" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.assetToDelete) +
                          "\n                    "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-muted fs-3" }, [
                    _vm._v(
                      "This plate will disappear from this device and anywhere else you use to read\n                    this record"
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "w-100",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-between align-content-center"
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "cursor-pointer p-3",
                          on: { click: _vm.cancelDelete }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "cursor-pointer p-3",
                          on: { click: _vm.deleteAsset }
                        },
                        [_vm._v("Confirm")]
                      )
                    ]
                  )
                ]
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b25518b8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b25518b8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./app/Shared/Resources/Assets/js/components/Plates.vue
// module id = 455
// module chunks = 0